import React, { useRef, useState } from 'react'
import {
    Line,
    XAxis,
    YAxis,
    Brush,
    CartesianGrid,
    Tooltip,
    LineChart,
    ResponsiveContainer,
    BarChart,
    Bar,
    Cell,
} from 'recharts'
import { GraphPlotStorage } from '../GraphPlotStorage'
import { connect } from 'react-redux'
import style from './Line.module.css'
import { graphSidebarData } from '../GraphsensorsPortData'

const CustomToolTipBarGraph = ({ hoverData, currentActiveData, cursorPos }) => {
    let value =
        currentActiveData?.[currentActiveData?.length - 1]?.[
            hoverData?.seriesLabel
        ]

    return hoverData?.seriesLabel && cursorPos.x && cursorPos.y && value ? (
        <div
            style={{
                position: 'fixed',
                // top: '0px',
                // left: '0px',
                top: cursorPos.y + 10,
                left: cursorPos.x + 10,
                background: '#fff',
                padding: '6px 10px',
                border: '1px solid #ccc',
                borderRadius: 4,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                zIndex: 10,
                pointerEvents: 'none', // so it doesn't block hover events
            }}
        >
            <strong>{hoverData.seriesLabel}</strong> — {value}
        </div>
    ) : (
        <></>
    )
}

function LineGraphChart({
    graphPlotStorage,
    currentActiveData,
    bar,
    containerRef,
}) {
    const [hoverData, setHoverData] = useState(null)
    const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })

    // console.log('gsk bar ', currentActiveData[currentActiveData.length - 1])
    const reduxInternalaccessories = graphPlotStorage.internalaccessories

    const handleMouseEnter = (dataKey, e) => {
        const newData = {
            seriesLabel: dataKey,
            // value: value,
        }
        if (
            !hoverData ||
            hoverData.seriesLabel !== newData.seriesLabel
            // hoverData.value !== newData.value
        ) {
            setHoverData(newData)
            let x = 0,
                y = 0
            if (containerRef) {
                const rect = containerRef.getBoundingClientRect()
                x = e.clientX - rect.left
                y = e.clientY - rect.top
            }
            setCursorPos({ x, y })
        }
    }

    const handleMouseLeave = () => {
        setHoverData(null)
    }

    const barCell = ({ barSize, dataKey, fill }) => {
        return (
            <Bar
                key={dataKey}
                dataKey={dataKey}
                // name={s.label}
                fill={fill}
                barSize={100}
            >
                <Cell
                    key={`${dataKey}`}
                    onMouseEnter={(e) => {
                        handleMouseEnter(dataKey, e)
                    }}
                    //   onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                    fill={fill}
                />
            </Bar>
        )
    }

    const renderSensors = (sensorData, ind) => {
        let reduxName = graphSidebarData[sensorData].reduxName
        if (
            [
                'distancesensor',
                'gesturesensor',
                'colorsensorRed',
                'colorsensorBlue',
                'colorsensorGreen',
                'lightsensor',
            ].includes(sensorData)
        ) {
            if (!reduxInternalaccessories.Four_in_one_sensor[reduxName]) return
        } else if (!reduxInternalaccessories[reduxName]) {
            return
        }

        if (bar) {
            return barCell({
                barSize: 100,
                dataKey: graphSidebarData[sensorData].dataKey,
                fill: graphSidebarData[sensorData].bgColour,
            })
            // <Bar
            //     barSize={100}
            //     dataKey={graphSidebarData[sensorData].dataKey}
            //     fill={graphSidebarData[sensorData].bgColour}
            // />
        } else {
            return (
                <Line
                    dataKey={graphSidebarData[sensorData].dataKey}
                    stroke={graphSidebarData[sensorData].bgColour}
                    strokeWidth="0.3%"
                />
            )
        }
    }

    const renderPortData = (portData) => {
        const activePorts = portData.ports.filter((port) => port.isActive)
        // console.log('gsk port active', currentActiveData)
        return activePorts.map((port) => (
            <>
                {bar ? (
                    barCell({
                        barSize: 100,
                        dataKey: `${port.portName}`,
                        fill: `${port.isColor}`,
                    })
                ) : (
                    // <Bar
                    //     dataKey={`${port.portName}`}
                    //     fill={`${port.isColor}`}
                    //     barSize={100}
                    // />
                    <Line
                        dataKey={`${port.portName}`}
                        stroke={`${port.isColor}`}
                        strokeWidth="0.3%"
                    />
                )}
            </>
        ))
    }

    return (
        <>
            <CustomToolTipBarGraph
                hoverData={hoverData}
                currentActiveData={currentActiveData}
                cursorPos={cursorPos}
            />
            <ResponsiveContainer
                min-width={300}
                className={
                    bar
                        ? style.Bar_recharts_container
                        : style.recharts_container
                }
            >
                {bar ? (
                    <BarChart
                        data={[currentActiveData[currentActiveData.length - 1]]}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        {/* <Tooltip /> */}
                        <XAxis allowDecimals={true} dataKey="mic" />
                        <YAxis domain={[0, 1]} />

                        {/* render the enable internal sensors graph */}
                        {Object.keys(graphSidebarData).map(
                            (accessoriesKey, ind) =>
                                renderSensors(accessoriesKey, ind)
                        )}

                        {graphPlotStorage.internalaccessories.portsData.map(
                            (portData) => (
                                <>{renderPortData(portData)}</>
                            )
                        )}
                    </BarChart>
                ) : (
                    <LineChart data={currentActiveData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <XAxis dataKey="pv" allowDecimals={true} />
                        <YAxis domain={[0, 1]} />

                        {/* render the enable internal sensors graph */}
                        {Object.keys(graphSidebarData).map(
                            (accessoriesKey, ind) =>
                                renderSensors(accessoriesKey, ind)
                        )}

                        {graphPlotStorage.internalaccessories.portsData.map(
                            (portData) => (
                                <>{renderPortData(portData)}</>
                            )
                        )}

                        {/* {isPauseBtn == false && currentActiveData.length > 10 ? (
                    <Brush height={15} dataKey="pv" />
                ) : null} */}
                        <Brush
                            startIndex={
                                currentActiveData.length <= 20
                                    ? 0
                                    : currentActiveData.length - 20
                            }
                        />
                    </LineChart>
                )}
            </ResponsiveContainer>
        </>
    )
}
const mapStateToProps = (state) => {
    return state
}
export default connect(mapStateToProps)(LineGraphChart)
